export default "__VITE_ASSET__a55c32bb__"